/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LuBilledAct } from './LuBilledAct';
import {
    LuBilledActFromJSON,
    LuBilledActFromJSONTyped,
    LuBilledActToJSON,
    LuBilledActToJSONTyped,
} from './LuBilledAct';

/**
 * 
 * @export
 * @interface LuBill
 */
export interface LuBill {
    /**
     * 
     * @type {number}
     * @memberof LuBill
     */
    luBillId: number;
    /**
     * 
     * @type {string}
     * @memberof LuBill
     */
    groupLicenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBill
     */
    billDate: string;
    /**
     * 
     * @type {string}
     * @memberof LuBill
     */
    invoiceReference: string;
    /**
     * 
     * @type {string}
     * @memberof LuBill
     */
    totalAmount: string;
    /**
     * 
     * @type {string}
     * @memberof LuBill
     */
    medicalJustification?: string;
    /**
     * 
     * @type {string}
     * @memberof LuBill
     */
    additionalInfo: string;
    /**
     * 
     * @type {Array<LuBilledAct>}
     * @memberof LuBill
     */
    luBilledActs: Array<LuBilledAct>;
}

/**
 * Check if a given object implements the LuBill interface.
 */
export function instanceOfLuBill(value: object): value is LuBill {
    if (!('luBillId' in value) || value['luBillId'] === undefined) return false;
    if (!('billDate' in value) || value['billDate'] === undefined) return false;
    if (!('invoiceReference' in value) || value['invoiceReference'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    if (!('additionalInfo' in value) || value['additionalInfo'] === undefined) return false;
    if (!('luBilledActs' in value) || value['luBilledActs'] === undefined) return false;
    return true;
}

export function LuBillFromJSON(json: any): LuBill {
    return LuBillFromJSONTyped(json, false);
}

export function LuBillFromJSONTyped(json: any, ignoreDiscriminator: boolean): LuBill {
    if (json == null) {
        return json;
    }
    return {
        
        'luBillId': json['luBillId'],
        'groupLicenceNumber': json['groupLicenceNumber'] == null ? undefined : json['groupLicenceNumber'],
        'billDate': json['billDate'],
        'invoiceReference': json['invoiceReference'],
        'totalAmount': json['totalAmount'],
        'medicalJustification': json['medicalJustification'] == null ? undefined : json['medicalJustification'],
        'additionalInfo': json['additionalInfo'],
        'luBilledActs': ((json['luBilledActs'] as Array<any>).map(LuBilledActFromJSON)),
    };
}

export function LuBillToJSON(json: any): LuBill {
    return LuBillToJSONTyped(json, false);
}

export function LuBillToJSONTyped(value?: LuBill | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'luBillId': value['luBillId'],
        'groupLicenceNumber': value['groupLicenceNumber'],
        'billDate': value['billDate'],
        'invoiceReference': value['invoiceReference'],
        'totalAmount': value['totalAmount'],
        'medicalJustification': value['medicalJustification'],
        'additionalInfo': value['additionalInfo'],
        'luBilledActs': ((value['luBilledActs'] as Array<any>).map(LuBilledActToJSON)),
    };
}

